import { render } from "./downloadApp.vue?vue&type=template&id=644dfd1a&scoped=true"
import script from "./downloadApp.vue?vue&type=script&lang=js"
export * from "./downloadApp.vue?vue&type=script&lang=js"

import "./downloadApp.vue?vue&type=style&index=0&id=644dfd1a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-644dfd1a"]])

export default __exports__